export default "__VITE_ASSET__ie2s3xC5__"